<template>
    <div class="content">
        <el-row :gutter="20">
            <el-col :span="17">
                <p style="line-height:30px;">{{jdnr}}</p>
                <el-form ref="form" :model="form" class="flxz">
                    <el-col :span="23">
                    <el-form-item label="">
                      <el-input type="textarea" :rows="12" placeholder="" v-model="form.content" :style="{width:'100%'}" @input="renew($event)"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="23">
                    <el-form-item size="large" label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit">确定</el-button>
                        <el-button type="danger" @click="cancel">取消</el-button>
                    </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
            <el-col :span="7">
              <ul class="zfmb">
                <li v-for="(item,index) in zfmbList" :key="index">
                  <p>
                    <el-checkbox :value="item.checked" @change="getActive(index)">{{item.mcjianxie}}</el-checkbox>
                  </p>
                </li>
              </ul>
            </el-col>
        </el-row>
        
        
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
    export default {
      components: {},
      props: ['wfss','jdnr'],
      data() {
        return {
          form:{
            content:'',
          },
          isActive:'-1',
          zfmbList:[],
          ysjy_year:'2022',
          ysjy_leibie:'类别',
          isShow:false
        }
      },
      watch:{
        text(){
          this.isActive = '-1'
        }
      },
      created() {

        // if(this.wfss){
        //   this.$set(this.form,'content',this.wfss)
        // }else{
        //   this.$set(this.form,'content','')
        // }
        this.getList();
      },
      async mounted() {
      },
      methods: {
        async getList(){

          
          // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfmbXX&leibie=${escape('合议记录上的说理内容')}`)
          // console.log(data)
          // if(data.data){
          //     let arr = data.data
          //     arr.forEach(item => {
          //       item.checked = false
          //     })
          //     arr.push({
          //         isMore: 0,
          //         mc: this.text,
          //         mcjianxie: '违法事实',
          //         checked:false,
          //     });
              
          //     this.zfmbList = arr
          // }
          console.log(this.wfss)
          this.zfmbList = [{
                  isMore: 0,
                  mc: this.wfss,
                  mcjianxie: '违法事实',
                  checked:false,
              }]
              console.log(this.zfmbList)
        },
        renew(e){
          this.$forceUpdate()
        },
        submit(){
          this.$emit("handleBackJdyj",this.form.content)
        },
        cancel(){
          this.$emit("jdyjTk",false)
        },

        getActive(index){
          
          console.log(index)
          
          this.$set(this.zfmbList[index],'checked',!this.zfmbList[index].checked)
          this.$forceUpdate()
          if(this.zfmbList[index].checked){
            this.getXunwennr(this.zfmbList[index])
          }
        },
        getXunwennr(item){
          console.log(this.form.content)
          if(this.form.content.indexOf(item.mc) != -1){
            this.$message.error('不能重复添加')
          }else{
            this.form.content = this.form.content ? this.form.content + item.mc : item.mc
          }
        },
      }
    }
</script>

<style scoped>
.content{position: relative;}
.zfmb{ border:1px solid #DCDFE6; padding: 20px;max-height: 500px; overflow-y: auto;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../../assets/images/wjj.png) no-repeat center left; margin-left: 30px;}
.zfmb2 span.dqSpan{color:#0C80E8;}
.zfmb2 span b{ display: none; position: absolute; top:40px;left: 120px; width: 600px; font-weight: normal; background:#303133; color: #fff;padding: 5px 10px;
    border-radius: 6px;}
.zfmb2 span:hover b{ display: block;}
.el-form >>> .el-textarea.is-disabled .el-textarea__inner { color: #333 !important;}
.content >>> .el-form-item {
    margin-bottom: 12px !important;
}


</style>
